import { useContext } from "react";

import { TenantContext } from "../../../../../templates/context/TenantContext";

import styled from "styled-components";
import { Select, SelectItem, Progress } from "@aidron/aidron-ds";

import { CustomHeading, CustomText, CustomCard } from "../../../../../components/StyledComponents/styleComponents.index";

import { getMonthName } from "../../../../../utils/utils";

import { i18n } from "../../../../../translate/i18n";

import { HierarchyGroupFilter } from "../../../../../components/SharedComponents/sharedComponents.index";

import PropTypes from "prop-types";
import { createIntFormatter, currencyFormatter } from "../../../../../utils/formatter/formatter";

const { t } = i18n;

const OuterContainer = styled.div`
  display: flex;
  block-size: 4rem;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-evenly;
  inline-size: 100%;

  div.menu-select-wrapper div.textfield-outer div.textfield-wrapper {
    border: 0.0625rem solid rgba(17, 24, 39, 0.125);
  }
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  padding-inline-end: 12rem;

  div.menu-select-wrapper div.textfield-outer div.textfield-wrapper {
    block-size: 20px !important;
    inline-size: 200px !important;
  }

  div.textfield-outer div.ragnarok.textfield-wrapper button {
    margin-top: 12px !important;
  }
`;

export function FiltersAndSums({ actions, ctx, uiState }) {

  const { setSelectedMonthsValue, setSelectedValue, } = actions || {};

  const { originalMonthColumns = [], selected, groupInformationData, opportunitySummary } = ctx || {};
  const { overstock = 0, increaseInSales = 0 } = opportunitySummary || {};
  
  const { selectedMonthsValue } = uiState || {};

  const { unit } = useContext(TenantContext);

  const formatAdjustPlanIndex = (number, unit) => {
    const absValue = Math.abs(number);

    const formattedValue =
      unit === "items"
        ? createIntFormatter().format(absValue)
        : currencyFormatter.format(absValue);

    return number > 0
      ? `-${formattedValue}`
      : `+${formattedValue}`;
  };

  const handleMonthSelection = (newSelectedValues) => setSelectedMonthsValue(newSelectedValues);

  if(!selected) {
    return (
      <div>
        <Progress circular />
      </div>
    )
  }

  return (
    <OuterContainer>
      <FiltersContainer>
        <HierarchyGroupFilter
          actions={{
            onChange: setSelectedValue
          }}
          ctx={{
            selected: selected.value,
            groupInformationData: groupInformationData,
            label: t("level"),
            direction: "column"
          }}/>

        <div style={{ display: "flex", flexDirection: "column", inlineSize: "100%", blockSize: "auto" }}>
          <CustomText fontSize={['0.4rem', '0.6rem', '1rem']} weight="bold" textAlign="center">
            {t("period")}
          </CustomText>

          <Select 
            readOnly 
            multiselect 
            label="" 
            selected={selectedMonthsValue} 
             handleChange={handleMonthSelection}>
            {originalMonthColumns.map(option => (
              <SelectItem value={option.predictionId} key={`prediction-${option.predictionId}-month-${option.month}`}>
                {`${getMonthName(option.month)} ${option.year.toString()}`}
              </SelectItem>
            ))}
          </Select>
        </div>
      </FiltersContainer>

      <div 
        style={{ 
          display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "end",
          inlineSize: "fit-content", gap: "1rem", paddingInlineStart: "12 rem"
        }}>
        <CustomCard 
          blockSize="auto" 
          boxShadow="0 4px 8px 0 rgb(0, 0, 0, 0.12)" 
          padding="0.3rem 0.2rem"
          inlineSize="fit-content"
          style={{ alignItems: "center" }}>

          <hgroup 
            style={{ 
              display: "grid", gridTemplateColumns: "3fr 4fr", placeItems: "center", 
              inlineSize: "fit-content", blockSize: "fit-content" }}>
            <CustomHeading fontSize={['0.3rem', '0.9rem', '1.3rem']} color="orange" inlineSize="fit-content" margin="0 0 0 1rem">
              {formatAdjustPlanIndex(overstock, unit)}
            </CustomHeading>

            <CustomText 
              weight="bold" 
              color="mediumGrey" 
              inlineSize="100%"
              textAlign="center"
              fontSize={['0.3rem', '0.6rem', '1rem']}
              margin="0 1rem 0 0">
              {t("avoidedStockSurplus")}
            </CustomText>
          </hgroup>
        </CustomCard>

        <CustomCard 
          blockSize="auto"
          boxShadow="0 4px 8px 0 rgb(0, 0, 0, 0.12)" 
          padding="0.3rem 0.2rem"
          inlineSize="fit-content"
          style={{ alignItems: "center" }}>

          <hgroup 
            style={{ 
              display: "grid", gridTemplateColumns: "3fr 4fr", placeItems: "center", 
              inlineSize: "fit-content", blockSize: "fit-content" }}>
            <CustomHeading color="orange"fontSize={['0.3rem', '0.9rem', '1.3rem']} inlineSize="fit-content" margin="0 0 0 1rem">
              {formatAdjustPlanIndex(increaseInSales, unit)}
            </CustomHeading>

            <CustomText 
              weight="bold" 
              color="mediumGrey" 
              inlineSize="100%"
              textAlign="center"
              fontSize={['0.3rem', '0.6rem', '1rem']}
              margin="0 1rem 0 0">
              {t("increaseInSales")}
            </CustomText>
          </hgroup>
        </CustomCard>
      </div>
    </OuterContainer>
  );
};

FiltersAndSums.propTypes = {
    actions: PropTypes.shape(),
    ctx: PropTypes.shape(),
    uiState: PropTypes.shape()
}